import React from 'react'

function Button({name, onClick, bool}) {
  return (
    <>
    <button 
      className={bool ?' bg-violet-500 w-full   px-4 py-4 border-none rounded-lg font-bold text-white': ' bg-violet-500   px-4 py-2 border-none rounded-lg font-bold text-white'}
      onClick={onClick}
      type='submit' 
     >{name}</button>   
    </>
  )
}

export default Button